define('pagination',[],function() {
	'use strict';

	return function(map, id, parentVM) {
		var self = this;

		self.total = (function() {
			return map.length;
		})();

		self.page = (function() {
			return map.indexOf(id) + 1;
		})();

		self.progress = (function() {
			return ((self.page * 100) / self.total) + '%';
		})();

		self.prevDisabled = (function() {
			return (self.page < 2);
		})();

		self.nextDisabled = (function() {
            // parentVM.training.returnFromSections could be changed to training module's modularMenuPageID (null if not modular navi)
            var isModular = (parentVM.training && parentVM.training.returnFromSections && !parentVM.entity.isQuizTask());
            var isQuizTask = (parentVM.training && parentVM.training.isQuizTask());
            var isQuizGameSubpage = (parentVM.training && parentVM.training.isQuizGameSubpage());

			return (self.page === self.total && !(isModular && !isQuizTask) && !isQuizGameSubpage);
		})();

		self.next = function() {
			var nextIndex		= 0,
				curIndex		= map.indexOf(id),
				courseLength	= map.length - 1;

			nextIndex = (curIndex >= courseLength) ? courseLength : curIndex + 1;

            if (parentVM && typeof parentVM.updateVM === 'function') {
                parentVM.updateVM(map[nextIndex]);
            }
		};

		self.prev = function() {
			var curIndex        = 0,
				prevIndex       = 0;

			curIndex = map.indexOf(id);
			prevIndex = (curIndex <= 0) ? 0 : curIndex - 1;

            if (parentVM && typeof parentVM.updateVM === 'function') {
                parentVM.updateVM(map[prevIndex]);
            }
		};

		// Need checking if prev required answer questions were answered
		self.goTo = function(target) {
			var index			= 0,
				courseLength	= map.length - 1;

			if ( target === +target && target === (target|0) ) {
				index = (target > courseLength) ? courseLength : target - 1;
			} else {
				index = map.indexOf(target);
			}

            if (parentVM && typeof parentVM.updateVM === 'function') {
                parentVM.updateVM(map[index]);
            }

		};
	};

});

